/**
 * @fileoverview The i18next namespace the login-string bundles register under.
 * @package @puffin-core/login-shell
 *
 * A ZERO-IMPORT leaf module, mirroring `@puffin-core/page-shell`'s
 * `strings/namespace.js`. `useLoginTranslate()` is imported by every login-shell
 * component; routing it through `strings/index.js` would drag `en.js` and `es.js`
 * into all of those import chains for the sake of a five-character constant.
 * The barrel re-exports this so `LOGIN_NAMESPACE` keeps a single public import site.
 */

/**
 * The canonical namespace under which login-shell strings live in i18next.
 * `useLoginTranslate()` returns a translator pre-bound to it.
 */
export const LOGIN_NAMESPACE = 'login';

export default LOGIN_NAMESPACE;
